import { render, staticRenderFns } from "./link-table-column-image-item.vue?vue&type=template&id=92e49304&"
import script from "./link-table-column-image-item.vue?vue&type=script&lang=js&"
export * from "./link-table-column-image-item.vue?vue&type=script&lang=js&"
import style0 from "./link-table-column-image-item.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports